import { clearUserDataFromStore, updateStore } from 'core_main/store';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
// Health check module is lazy-loaded to reduce initial bundle size

export const stop = () => {
  // Clean up event listeners and timers set up by init()
  // Reset checkAndReconnect module state to prevent stale state on re-initialization
  // Lazy-load the health check module only when needed (during stop)
  const cleanupPromise = import(
    /* webpackChunkName: "pubnub-health-check" */ 'core_main/pubnub/helpers/checkAndReconnect'
  ).then((module) => {
    module.cleanupHealthCheckMonitoring();
    module.resetCheckAndReconnectState();
  }).catch(() => {
    // Ignore errors - if module isn't loaded yet, there's nothing to clean up or reset
  });

  return Promise.all([cleanupPromise, importAndInitializePubNub()]).then(([, pubnub]) => {
    clearUserDataFromStore();
    pubnub.stopPubNub();
    updateStore('isPubNubConnected', false);
  });
};
